var React = require('react');

function OpenInNew (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2778 4V5.77778H17.4689L8.73111 14.5156L9.98444 15.7689L18.7222 7.03111V10.2222H20.5V4M18.7222 18.2222H6.27778V5.77778H12.5V4H6.27778C5.29111 4 4.5 4.8 4.5 5.77778V18.2222C4.5 18.6937 4.6873 19.1459 5.0207 19.4793C5.3541 19.8127 5.80628 20 6.27778 20H18.7222C19.1937 20 19.6459 19.8127 19.9793 19.4793C20.3127 19.1459 20.5 18.6937 20.5 18.2222V12H18.7222V18.2222Z","fill":"#0076CC"}));
}

OpenInNew.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = OpenInNew;

OpenInNew.default = OpenInNew;
